// src/App.js
import React,{useEffect} from "react";
import { BrowserRouter as Router, Route, Routes, } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import LogInPage from "./pages/LogInPage";
import HomePage from "./pages/HomePage";
import PDLManagementPage from "./pages/PDLManagementPage";
import LoadMoneyPage from "./pages/LoadMoneyPage";
import MerchantPage from "./pages/MerchantPage";
import MerchantDetail from "./pages/MerchantDetail";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import MerchantPage_Edit from "./pages/MerchantPage_Edit";
import MerchantPage_Add from "./pages/MerchantPage_Add";
import LoadMerchantPage from "./pages/LoadMerchantPage";
import PadalaReports from "./pages/PadalaReports";
import KioskReports from "./pages/KioskReports";
import OtpPage from "./pages/OtpPage";
import ColonySelectionPage from "./pages/ColonySelectionPage";
import PDLTransactions from "./pages/PDLTransactions";
import BeuPadalaReports from "./pages/BeuCorPadalaReports";
import PadalaReportsFloating from "./pages/PadalaReportsFloating";
import ReprocessPadala from "./pages/ReprocessPadala";
import RFQPage from "./pages/RFQPage";
import SettingsPage from "./pages/SettingsPage";
import LogReports from "./pages/LogReports.js";
import KioskStatusReports from "./pages/KioskStatusReports";
import RFQList from "./pages/RFQList";
import KioskPageAdd from "./pages/KioskPageAdd";
import POList from "./pages/POList";
import POPage from "./pages/POPage";
import ReceivingPage from "./pages/ReceivingPage";
import MPOPage from "./pages/MPOPage";
import POSStatusReports from "./pages/POSStatusReports";
import FundTransferPage from "./pages/FundTransferPage";
import MerchantTransactions from "./pages/MerchantTransactions";
import NotFound from "./pages/NotFound";
import VoidTransactions from "./pages/VoidTransactions";
import MerchantPadalaReports from "./pages/MerchantPadalaReports";
import PosOverallReport from "./pages/POSOverallReport.js";
import UserPage from "./pages/UserPage.js";
import IcarusWebApp from "./pages/IcarusWebApp.js";
import IPXTransactions from "./pages/IPXTransactions.js";
import ForgotPassword from "./pages/ForgotPassword.js";
import ResetPassword from "./pages/ResetPassword.js";
import KioskPageEdit from "./pages/KioskPageEdit.js";
import CashOutRequests from "./pages/CashOutRequests.js";
import AccountabilityReport from "./pages/AccountabilityReport.js";
import Categories from "./pages/Categories.js";
import OrdersInventory from "./pages/OrdersInventory.js";
import '@fortawesome/fontawesome-free/css/all.min.css';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EcpayReport from "./pages/EcpayReport.js";
import PdlToMerchantPage from "./pages/PdlToMerchantPage.js";
import IcarusAccounts from "./pages/IcarusAccounts.js";
import FundTransferReport from "./pages/FundTransferReport.js";
import BucorModule from "./pages/BucorModule.js";
import BucorOrderDetail from "./pages/BucorOrderDetail.js";
import BucorItemApprovalDetail from "./pages/BucorItemApprovalDetail.js";
import NodeSyncPage from "./pages/NodeSyncPage.js";
import DltCorrectionPage from "./pages/DltCorrectionPage.js";

const App = () => {

  // useEffect(() => {
  //     const checkDebugger = setInterval(() => {
  //     const start = performance.now();
  //     debugger; // Execution pauses if DevTools is open
  //     const end = performance.now();

  //     // Detecting Firefox (based on execution delay)
  //     const firefoxDetected = end - start > 100;

  //     // Detecting Chrome & Edge (window resizing trick)
  //     const devToolsOpen =
  //       window.outerWidth - window.innerWidth > 100 ||
  //       window.outerHeight - window.innerHeight > 100;

  //     if (firefoxDetected || devToolsOpen) {
  //       localStorage.clear();
  //       window.location.href = "/"; // Redirect to login
  //     }
  //   }, 3000);

  //   return () => clearInterval(checkDebugger);
  // }, []);

  return (
    <Router>
      <ToastContainer
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        rtl={false}
        theme="colored"
       />
      <Routes>
        
        <Route path="/" element={<LogInPage />} />
        <Route path="/verify-otp" element={<OtpPage />} />
        <Route path="/colony-selection" element={<ColonySelectionPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="*"
          element={
            <AppLayout>
              <Routes>
                <Route path="/icarus-web" element={<IcarusWebApp />} />
                 <Route path="/icarus-accounts" element={<IcarusAccounts />} />
                <Route path="/" element={<NotFound />} />
                <Route path="/dashboard" element={<HomePage />} />
                <Route path="/accountability-report" element={<AccountabilityReport />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/orders-inventory" element={<OrdersInventory />} />
                <Route path="/bucor-module" element={<BucorModule />} />
                <Route path="/bucor-order-detail" element={<BucorOrderDetail />} />
                <Route path="/bucor-item-approval-detail" element={<BucorItemApprovalDetail />} />
                <Route path="/ipx-transactions" element={<IPXTransactions />} />
                <Route path="/cashout-requests" element={<CashOutRequests />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/load-money" element={<LoadMoneyPage />} />
                <Route path="/fund-transfer" element={<FundTransferPage />} />
                <Route path="/load-merchant" element={<LoadMerchantPage />} />
                <Route path="/merchant" element={<MerchantPage />} />
                <Route path="/merchant/detail" element={<MerchantDetail />} />
                <Route path="/merchant/edit/:merchantId" element={<MerchantPage_Edit />} />
                <Route path="/merchant/add" element={<MerchantPage_Add />} />
                <Route path="/pdl-management" element={<PDLManagementPage />} />
                <Route path="/padala-reports" element={<PadalaReports />} />
                <Route path="/merchant-padala-reports" element={<MerchantPadalaReports />} />
                <Route path="/pos-sales-reports" element={<PosOverallReport />} />
                <Route path="/users-page" element={<UserPage />} />
                <Route path="/beucor-padala-reports" element={<BeuPadalaReports />} />
                <Route path="/floating-padala-reports" element={<PadalaReportsFloating />} />
                <Route path="/kiosk-reports" element={<KioskReports />} />
                <Route path="/void-transactions" element={<VoidTransactions />} />
                <Route path="/kiosk-add" element={<KioskPageAdd />} />
                <Route path="/kiosk-edit/:kioskId" element={<KioskPageEdit />} />
                <Route path="/pdl-transactions" element={<PDLTransactions />} />
                <Route path="/reprocess" element={<ReprocessPadala />} />
                <Route path="/rfq" element={<RFQPage />} />
                <Route path="/rfq-list" element={<RFQList />} />
                <Route path="/po-list" element={<POList />} />
                <Route path="/receiving" element={<ReceivingPage />} />
                <Route path="/po" element={<POPage />} />
                <Route path="/mpo" element={<MPOPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/logs" element={<LogReports />} />
                <Route path="/kiosk-status-reports" element={<KioskStatusReports />} />
                <Route path="/pos-status-reports" element={<POSStatusReports />} />
                <Route path="/merchant-transactions" element={<MerchantTransactions />} />
                <Route path="/ecpay" element={<EcpayReport />} />
                <Route path="/pdl-to-merchant" element={<PdlToMerchantPage />} />
                <Route path="/fund-transfer-report" element={<FundTransferReport />} />
                <Route path="/node-sync" element={<NodeSyncPage />} />
                <Route path="/dlt-correction" element={<DltCorrectionPage />} />
              </Routes>
            </AppLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
